import { ModuleConfig } from '@schamburg-web/interfaces';
import { ImageMarker } from '@schamburg-web/lakecounty';
import { snowplowIcon } from '.';

const SnowplowMarker: React.FC<{
  icon: any;
  module: ModuleConfig;
}> = ({ icon, module }) => {
  const heading = icon.heading ?? 0; // Default to 0 if no heading present

  return (
    <ImageMarker
      src={snowplowIcon}
      name={module.name}
      showOutline={false}
      heading={heading}
    />
  );
};

export default SnowplowMarker;
